module.exports = __webpack_public_path__ + "media/images/logo_digitalwerk_normal-0f4f9651d0425658db8ca4e69e6f19db.png";